import {Injectable} from '@angular/core';
import {phone} from 'phone';
import {PhonePrefix} from 'src/app/domain/model/country/phone-prefix.model';
import {CountryCode} from 'src/app/domain/service/api/country/country-code';

@Injectable({
  providedIn: 'root',
})
export class PhoneService {
  public readonly spainPhonePrefix: PhonePrefix = {
    country: 'Espa\u00f1a',
    prefix: '34',
  };

  public readonly spainCountryCode: CountryCode = {
    code: 'ES',
    name: 'Espa\u00f1a',
  };

  public isPhoneValid(phoneNumber: string, countryISO: string = ''): boolean {
    const result = phone(phoneNumber, {country: countryISO});
    return result.isValid;
  }

  public getPhonePrefix(phoneNumber: string): string {
    const result = phone(phoneNumber);
    return result.countryCode;
  }
}
